export default [
    {
        title: 'tributacion.menu_title',
        fontIcon: 'file-contract',
        resource: 'Tributacion',
        action: 'ver-tributacion',
        children: [
            {
                title: 'global.menu.dashboard',
                icon: 'LayoutIcon',
                resource: 'Tributacion',
                action: 'ver-tributacion-dashboard',
            },
            {
                title: 'global.menu.configuracion',
                icon: 'SettingsIcon',
                resource: 'Tributacion',
                action: 'ver-tributacion-configuracion',
                children: [
                    {
                        route: 'configuracion-impuesto-renta',
                        title: 'tributacion.configuracion.parametros_rdep.menu_title',
                        resource: 'Tributacion',
                        action: 'ver-tributacion-parametros',
                    },
                    //diego
                    {
                        route: 'tributacion-configuracion-paises',
                        title: 'tributacion.subopciones.paises',
                        resource: 'Tributacion',
                        action: 'ver-tributacion-configuracion-paises',
                    },
                    {
                        route: 'tributacion-configuracion-aduanero',
                        title: 'tributacion.subopciones.distrito_aduanero',
                        resource: 'Tributacion',
                        action: 'ver-tributacion-configuracion-distrito_aduanero',
                    },
                    {
                        route: 'tributacion-configuracion-fideicomiso',
                        title: 'tributacion.subopciones.fideicomiso',
                        resource: 'Tributacion',
                        action: 'ver-tributacion-configuracion-fideicomiso',
                    },
                    {
                        route: 'tributacion-configuracion-forma-pago',
                        title: 'tributacion.subopciones.forma_pago_cobro',
                        resource: 'Tributacion',
                        action: 'ver-tributacion-configuracion-forma-pago',
                    },
                    {
                        route: 'tributacion-configuracion-sustento-comprobante',
                        title: 'tributacion.subopciones.sustento_comprobante',
                        resource: 'Tributacion',
                        action: 'ver-tributacion-configuracion-sustento-comprobante',
                    },
                    {
                        route: 'tributacion-configuracion-retencion-iva',
                        title: 'tributacion.subopciones.retencion_iva',
                        resource: 'Tributacion',
                        action: 'ver-tributacion-configuracion-retencion-iva',
                    },
                    {
                        route: 'tributacion-configuracion-tipo-exportacion-ingreso-exterior',
                        title: 'tributacion.subopciones.exportacion_ingreso_exterior',
                        resource: 'Tributacion',
                        action: 'ver-tributacion-configuracion-tipo-exportacion-ingreso-exterior',
                    },
                    /* Jose Pacheco */
                    {
                        route: 'tributacion-configuracion-ciudades',
                        title: 'tributacion.subopciones.ciudades',
                        resource: 'Tributacion',
                        action: 'ver-tributacion-configuracion-ciudades',
                    },
                    {
                        route: 'tributacion-configuracion-CierreSRI',
                        title: 'tributacion.subopciones.cierre_sri',
                        resource: 'Tributacion',
                        action: 'ver-tributacion-configuracion-CierreSRI',
                    },
                    {
                        route: 'tributacion-configuracion-tipo-comprobante',
                        title: 'tributacion.subopciones.tipo_comprobante',
                        resource: 'Tributacion',
                        action: 'ver-tributacion-configuracion-tipo-comprobante',
                    },
                    {
                        route: 'tributacion-configuracion-punto-emision',
                        title: 'tributacion.subopciones.punto_emision',
                        resource: 'Tributacion',
                        action: 'ver-tributacion-configuracion-punto-emision',
                    },
                ],
            },
            {
                title: 'global.menu.mantenimiento',
                icon: 'EditIcon',
                resource: 'Tributacion',
                action: 'ver-tributacion-mantenimiento',
                children: [
                    {
                        route: 'secuencial-documentos-emitidos',
                        title: 'tributacion.subopciones.secuencial_documento',
                        resource: 'Tributacion',
                        action: 'ver-tributacion-secuencial',
                    },

                    //ventana para otorgar permisos a las diferentes ventanas de tributación
                    {
                        route: 'tributacion-permisos-ventanas-tributacion',
                        title: 'tributacion.subopciones.permiso_ventana_tributacion',
                        // resource: "Tributacion",
                        // action: "ver-tributacion-permisos-ventanas-tributacion",
                    },
                    //parametrizaciones tributacion 2022
                    {
                        title: 'tributacion.transacciones.parametrizacion_ats.menu_title',
                        resource: 'Tributacion',
                        action: 'ver-tributacion-parametrizaciones',
                        children: [
                            {
                                route: 'tributacion-tipo-transaccion',
                                title: 'tributacion.transacciones.parametrizacion_ats.subopciones.tipo_transaccion',
                                resource: 'Tributacion',
                                action: 'ver-tributacion-tipo-transaccion',
                            },

                            {
                                route: 'tributacion-conceptos-retencion-fuente',
                                title: 'tributacion.transacciones.parametrizacion_ats.subopciones.conceptos_retencion',
                                resource: 'Tributacion',
                                action: 'ver-tributacion-conceptos-retencion-fuente',
                            },
                            {
                                route: 'tributacion-tipo-comprobantes',
                                title: 'tributacion.transacciones.parametrizacion_ats.subopciones.tipo_comprobante',
                                resource: 'Tributacion',
                                action: 'ver-tributacion-tipo-comprobantes',
                            },
                            {
                                route: 'tributacion-codigo-regimen',
                                title: 'tributacion.transacciones.parametrizacion_ats.subopciones.codigo_regimen',
                                resource: 'Tributacion',
                                action: 'ver-tributacion-codigo-regimen',
                            },
                            {
                                route: 'tributacion-parametrizacion-contribuyente',
                                title: 'tributacion.transacciones.parametrizacion_ats.subopciones.parametrizacion_contribuyente_proveedor',
                                resource: 'Tributacion',
                                action: 'ver-tributacion-parametrizacion-contribuyente',
                            },
                            {
                                route: 'tributacion-SRI-Control-de-Errores-Usuarios-Contables',
                                title: 'tributacion.transacciones.parametrizacion_ats.subopciones.control_error_usuarios',
                                resource: 'Tributacion',
                                action: 'ver-tributacion-SRI-Control-de-Errores-Usuarios-Contables',
                            },
                        ],
                    },
                    {
                        route: 'tributacion-crear-provincia',
                        title: 'tributacion.subopciones.crear_provincia',
                        resource: 'Tributacion',
                        action: 'ver-tributacion-crear-provincia',
                    },
                ],
            },
            {
                title: 'global.menu.transacciones',
                fontIcon: 'exchange-alt',
                resource: 'Tributacion',
                action: 'ver-tributacion-transacciones',
                children: [
                    {
                        title: 'tributacion.subopciones.RDEP',
                        resource: 'Tributacion',
                        action: 'ver-tributacion-rdep',
                        children: [
                            {
                                route: 'tributacion-migrar-excel',
                                title: 'tributacion.subopciones.migrar_excel',
                                resource: 'Tributacion',
                                action: 'ver-tributacion-migrar-excel',
                            },
                            {
                                route: 'tributacion-procesos-RDEP',
                                title: 'tributacion.subopciones.generar_xml',
                                resource: 'Tributacion',
                                action: 'ver-tributacion-generar-xml',
                            },
                        ],
                    },
                    {
                        title: 'tributacion.subopciones.ATS',
                        resource: 'Tributacion',
                        action: 'ver-tributacion-ATS',
                        children: [
                            {
                                route: 'tributacion-migrar-excel-ATS',
                                title: 'tributacion.subopciones.migrar_excel_ats',
                                resource: 'Tributacion',
                                action: 'ver-tributacion-migrar-excel-ATS',
                            },
                        ],
                    },
                    //Diego
                    {
                        route: 'tributacion-transacciones-retenciones',
                        title: 'tributacion.subopciones.retenciones',
                        resource: 'Tributacion',
                        action: 'ver-tributacion-transacciones-retenciones',
                    },
                ],
            },
            {
                title: 'global.menu.informes',
                resource: 'Tributacion',
                fontIcon: 'file-prescription',
                action: 'ver-tributacion-informes',
                children: [
                    {
                        route: 'tributacion-reporte-Form103',
                        title: '103',
                        resource: 'Tributacion',
                        action: 'ver-tributacion-reporte-103',
                    },
                    {
                        route: 'tributacion-reporte-Form107',
                        title: '107',
                        resource: 'Tributacion',
                        action: 'ver-tributacion-reporte-107',
                    },
                    //DG
                    {
                        route: 'tributacion-reporte-ComprasServicios',
                        title: 'tributacion.subopciones.compras_servicios',
                        resource: 'Tributacion',
                        action: 'ver-tributacion-reporte-comprasServicios',
                    },
                    {
                        route: 'tributacion-reportesRDEP-tabulador',
                        title: 'tributacion.informes.reportes_tabulados.title',
                        resource: 'Tributacion',
                        action: 'ver-tributacion-reporte-tabulado-rdep',
                    },
                    {
                        route: 'tributacion-reporte-ventasat',
                        title: 'tributacion.subopciones.at_ventas',
                        resource: 'Tributacion',
                        action: 'ver-tributacion-reporte-ventasat',
                    },
                ],
            },
        ],
    },
]
